import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';

// Reducers & Slices
import { coreSlice } from './core/core.slice';
import { userSlice } from './user/user.slice';
import { appNotificationsSlice } from './app-notifications/app-notifications.slice';
import { paymentsSlice } from './payments/payments.slice';
import { loaderSlice } from './loader/loader.slice';
import { socketSlice } from './socket/socket.slice';
import { transactionsSlice } from './transactions/transactions.slice';
import { authSlice } from './auth/auth.slice';
import { paymentsTypesSlice } from './payments-types/payments-types.slice';

import { counsellorsSlice } from './counsellors/counsellors.slice';
import { currentCounsellorSlice } from './current-counsellor/current-counsellor.slice';
import { dashboardSlice } from './dashboard/dashboard.slice';
import { notificationsSlice } from './notifications/notifications.slice';
import { companySlice } from './company/company.slice';
import { staticPagesSlice } from './static-pages/static-pages.slice';
import { permissionSettingsSlice } from './permission-settings/permission-settings.slice';
import { sessionSettingsSlice } from './session-settings/session-settings.slice';
import { profileSettingsSlice } from './profile-settings/profile-settings.slice';
import { currencySlice } from './currency/currency.slice';
import { billingSlice } from './billing/billing.slice';
import { widgetSettingsSlice } from './widget-settings/widget-settings.slice';

const reducers = {
  core: coreSlice.reducer,
  transactions: transactionsSlice.reducer,
  auth: authSlice.reducer,
  user: userSlice.reducer,
  appNotifications: appNotificationsSlice.reducer,
  payments: paymentsSlice.reducer,
  paymentsTypes: paymentsTypesSlice.reducer,
  loader: loaderSlice.reducer,
  socket: socketSlice.reducer,
  counsellors: counsellorsSlice.reducer,
  currentCounsellor: currentCounsellorSlice.reducer,
  dashboard: dashboardSlice.reducer,
  notifications: notificationsSlice.reducer,
  company: companySlice.reducer,
  staticPages: staticPagesSlice.reducer,
  permissionSettings: permissionSettingsSlice.reducer,
  sessionSettings: sessionSettingsSlice.reducer,
  profileSettings: profileSettingsSlice.reducer,
  currency: currencySlice.reducer,
  billing: billingSlice.reducer,
  widgetSettings: widgetSettingsSlice.reducer,
}

const rootReducer = combineReducers(reducers);

const resetRootReducer = (state: any, action: AnyAction) => {
  if (action.type === 'user/logoutSuccess' || action.type === 'user/deleteLogoutRequest') {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resetRootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export type TRootState = ReturnType<typeof store.getState>;
